import { palette } from '../../theme/paletteV2.ts';

export const DEFAULT_LEFT_COLOR = palette.primary.main;
export const DEFAULT_RIGHT_COLOR = palette.success.main;
export const DEFAULT_HEIGHT = 280;
export const CENTER_LABEL_WIDTH = 56;
export const BAR_RADIUS = 10;
export const X_AXIS_HEIGHT = 28;

/** Loading skeleton: rows whose bars shrink by `step` % per row from `start` %, hinting a pyramid shape */
export const PLACEHOLDER_ROWS = 6;
export const PLACEHOLDER_LEFT_WIDTH = { start: 55, step: 6 };
export const PLACEHOLDER_RIGHT_WIDTH = { start: 50, step: 5 };
